module.exports = __webpack_public_path__ + "img/tips6.bc05a210.png";